import {Component, Input, OnInit} from '@angular/core';
import StyleFormatter from '../../../utils/style-formatter';
import _ from "lodash";

@Component({
  selector: 'properties-dictionary-summary',
  templateUrl: './properties-dictionary-summary.component.html',
  styleUrls: ['./properties-dictionary-summary.component.scss']
})
export class PropertiesDictionarySummaryComponent implements OnInit {

  styleFormatter;
  selected;

  @Input() set selection(selection){
    if (selection){
      this.selected = selection;
      if (selection.isCombined){
        this.selected.combinationProperty1 = this.getAttributeName(selection.combinationPropertyId1);
        this.selected.combinationProperty2 = this.getAttributeName(selection.combinationPropertyId2);
      }
    }
  }

  @Input() attributeOptions;

  constructor() {
    this.styleFormatter = StyleFormatter;
  }

  ngOnInit(): void {

  }

  getAttributeName(id: number): string {
    return _.find(this.attributeOptions, {id}).name;
  }
}


